
import { controls } from "../../controls";


const guarantor = {
  label: "guarantor Loan Details",
  pageLabel: "guarantor Loan Details",
  starting: true,
  url: "guarantor",
  pageType: "history",
  formState: { checked: "view" },
  formActions: { edit: { allow: true }, delete: { allow: true } },
  // "Address.",
  form: [

    ...controls.displayText({ label: "CIN", width: "col-sm-2" }),
    ...controls.customerNumber({ width: "col-sm-2" }),
    ...controls.displayText({ label: "Type", width: "col-sm-2" }),
    ...controls.select({ placeHolder: "Type",name: "type", width: "col-sm-2" ,options:[
        {label:"Regular",value:"Regular" },{label:"Associated",value:"Associated" },{label:"Nominal",value:"Nominal(B class)" }]}),     
    ...controls.displayText({  width: "col-sm-2", label:"Full Name" }),
    ...controls.showData({name: "customer_fullname_display", data: "customer_fullname_display", width: "col-sm-2" }),
  
    ...controls.displayText({ label: "Member No", width: "col-sm-2" }),
    ...controls.MemberNo({width: "col-sm-2" }),
    
    ...controls.displayText({ label: "Date Added", width: "col-sm-2" }),
    ...controls.datePicker({name:"date_added",width:"col-sm-2"}),
    ...controls.checkBox({label: "Active",name: "isActive",width:"col-sm-2",default:"true"}),

    ...controls.button({
        label: "ADD", onclick: {
          action: "appendToHTMLTable",
          tableNameField: 'guarantorloan_table',
          requiredField: ["customer_number", "type","member_no","customer_fullname_display","date_added","isActive"]
        }, width: "col-sm-2"
      }),
      {
        inputType: "table",
        tableTitle: "",
        // convertedTo: "nominee_table",
        deletable: true,
        // editable: true,
        // addRows: true,
        tableHeaders: [
          { label: "Sr", type: "autoinc" },
          { label: "CIN", field: "customer_number"},
          { label: "Type", field: "type"},
          { label: "Member No", field: "member_no" },
          { label: "Name", field: "customer_fullname_display"},    
          { label: "Date Added", field: "date_added",displaytype: 'date' },
          { label: "Active", field: "isActive" ,displaytype:"tick"},
        ],
        widths: {
          parent: "col-sm-12",
          children: "col-sm-12"
        },
        name: "guarantorloan_table"
      },
      ...controls.displayText({ label: "Address", width: "col-sm-2" }),
      ...controls.showData({name:"address",data:"address",width:"col-sm-4"})

   
  ]
}

export default guarantor;